import { z } from 'zod'

export const managementOpinionSchema = z
	.object({
		description: z.string().refine((data) => data.length !== 0, {
			message: 'Required',
			path: ['description'],
		}),
		priority: z.number().refine((data) => data || data !== 0, {
			message: 'Required',
			path: ['priority'],
		}),
		targetUser: z.string().optional(),
	})
	.strict()
